/** @jsx jsx */
import type { PropsWithChildren } from 'react';
import { jsx } from '@compiled/react';
import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { MenuListItem } from '@atlaskit/navigation-system';

const styles = cssMap({
	box: {
		marginLeft: token('space.050'),
	},
});

export function EmptyContentMenuItem({ children }: PropsWithChildren): JSX.Element {
	return (
		<MenuListItem>
			<Box paddingInline="space.050" xcss={styles.box}>
				{children}
			</Box>
		</MenuListItem>
	);
}
